import { render, staticRenderFns } from "./OCRadio.vue?vue&type=template&id=a823db60&scoped=true&"
import script from "./OCRadio.vue?vue&type=script&lang=ts&"
export * from "./OCRadio.vue?vue&type=script&lang=ts&"
import style0 from "./OCRadio.vue?vue&type=style&index=0&id=a823db60&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "a823db60",
  null
  
)

export default component.exports